import { render } from "./StudentHeader.vue?vue&type=template&id=546f8a12"
import script from "./StudentHeader.vue?vue&type=script&lang=js"
export * from "./StudentHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__